import React, { useState } from "react";
import Chevron from "../../assets/images/common/chevron-right.svg";
import "../../assets/css/laboratory/laboratorylist/laboratorylist.scss";
import Searchbar from "./../../components/common/Searchbar";
import LaboratoryListDateTable from "../../components/laboratory/laboratorylist/LabListDataTable";
import AddLaboratoryModal from "../../components/laboratory/laboratorylist/AddLaboratoryModal";
import AddRoleModal from "../../components/laboratory/laboratorylist/AddRoleModal";
import EditLaboratoryModal from "../../components/laboratory/laboratorylist/EditLaboratoryModal";
import DeleteModal from "../../components/common/DeleteModal";

const LaboratoryList = () => {
  const [rows, setRows] = useState([
    {
      number: 1,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 2,
      name: "Green ",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 3,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 4,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 5,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 6,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
    {
      number: 7,
      name: "Clinix",
      email: "sohaibbutt57@gmail.com",
      address: "Bidadari Park Drive Singapore",
      mobileNo: "+91-955-555-4751",
      country: "Kuwait",
      state: "kuwait City",
      zipCode: "5400",
      edit: "pending",
    },
  ]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAddLaboratoryModal, setshowAddLaboratoryModal] = useState(false);
  const [showRoleModal, setshowRoleModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Search Functionality
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleAddLaboratory = () => {
    setshowAddLaboratoryModal(true);
  };

  const handleAddRole = () => {
    setshowRoleModal(true);
  };

  //   handleEditClickModal handler
  const handleEditClick = () => {
    setShowEditModal(true);
  };

  //  handleDeleteClickModal handlar
  const handleDeleteClick = () => {
    setShowDeleteModal(true);
  };

  return (
    <>
      <AddLaboratoryModal
        open={showAddLaboratoryModal}
        onClose={() => setshowAddLaboratoryModal(false)}
      />
      <AddRoleModal
        open={showRoleModal}
        onClose={() => setshowRoleModal(false)}
      />

      <EditLaboratoryModal
        open={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSave={handleEditClick}
      />
      <DeleteModal
        open={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={handleDeleteClick}
      />
      <div className="row pl-3 pr-2 pt-4 laboratorylist-tab">
        <div className="col-12">
          <p className="mb-0 laboratorylist-heading">Laboratory List</p>
        </div>

        {/* header  */}
        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-6">
              <p className="laboratorylist-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> LABORATORY</span>
                <img src={Chevron} />
                <span className="current-tab">LABORATORY LIST</span>
              </p>
            </div>

            <div class="col-md-6 text-md-right ">
              <button
                onClick={handleAddRole}
                style={{ marginRight: "15px" }}
                type="button"
                class="add-role"
              >
                Add a Role
              </button>
              <button
                onClick={handleAddLaboratory}
                type="button"
                class="add-laboratory"
              >
                Add Laboratory
              </button>
            </div>
          </div>
          <div className="row m-0 p-0 ">
            <Searchbar onChange={handleSearchChange} value={searchQuery} />
          </div>
        </div>

        {/* Table */}
        <div className="col-12 mb-5 pb-5">
          <LaboratoryListDateTable
            onEditClick={handleEditClick}
            onDeleteClick={handleDeleteClick}
            rows={rows}
            searchQuery={searchQuery}
          />
        </div>
      </div>
    </>
  );
};

export default LaboratoryList;
